import React from "react";
import ReactGA from "react-ga4";
import NavBar from "../util/NavBar3";
import { Dashboard } from "../Dashboard/_Dashboard";
import RevenueCommandCenter from "../RevenueCommandCenter/Index";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { appService } from "./app.service";
import { toastSuppressionService } from '../services/toastSuppressionService';
import { LoginView } from "../Login/Login";
import { withSnackbar } from "notistack";
import * as Yup from "yup";
import { Formik } from "formik";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  Box,
  TextField,
  Button,
  IconButton,
  InputAdornment,
  Typography,
  CssBaseline,
} from "@material-ui/core";
//import Cookies from 'universal-cookie'
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";
import { EnhancedInsights } from "../EnhancedInsights/EnhancedInsights";
import { RepPerformance } from "../RepPerformance/RepPerformance";
import { ProductInsights } from "../ProductInsights/ProductInsights";
import { Settings } from "../Settings/Settings";
import ViewIcon from "@material-ui/icons/Visibility";
import OffIcon from "@material-ui/icons/VisibilityOff";
import ErrorBoundary from "../components/ErrorBoundary";
import { CustomerSuccessV2 as CustomerSuccess } from "../CustomerSuccess/CustomerSuccessV2";
import { EnhancedInsightsV2 } from "../EnhancedInsights/EnhancedInsightsV2";
import { Favourites } from "../Favourites/Favourites";
import { RepPerformanceV2 } from "../RepPerformance/RepPerformanceV2";
import { QuotaLetters } from "../GenerateQuotaLetters/GenerateQuotas";
import AutoUpdateAlert from "../components/Containers/AutoUpdateAlert";
import {
  passwordValidation,
  passwordValidationLabel,
} from "../Settings/AccountSettings/password-validaton";
import ResetPasswordFormikComponent from "./ResetPasswordFormikComponent";
import { OtherInsights } from "../EnhancedInsights/OtherInsights";
import MarketingRequests from "../MarketingRequests/MarketingRequests";
import { GrowthModeling } from "../EnhancedInsights/GrowthModeling";
import { PipelineandBuildSuffiecy } from "../EnhancedInsights/PipelineBuildAndSufficiency";
import {PipelineVelocityandConversion} from "../EnhancedInsights/PipelineVelocityandConversion"
import {MarketIntelandGrowthLevers} from "../EnhancedInsights/MarketIntelandGrowthLevers"
import {SalesProductivity} from "../EnhancedInsights/SalesProductivity"
import {GrowthScienceInsights} from "../EnhancedInsights/GrowthScienceInsights"
import {PersonalizedScorecards} from "../EnhancedInsights/PersonalizedScorecards"
import { PipelineProgressionCharts } from "../EnhancedInsights/PipelineProgressionCharts";

const styles = (theme) => ({
  root: {
    width: "100%",
    height: "100%",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  "@global": {
    "*::-webkit-scrollbar": {
      width: "1rem",
      height: "1rem",
    },
    "*::-webkit-scrollbar-track": {
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.15)",
      borderRadius: "1rem",
    },
    "*::-webkit-scrollbar-thumb": {
      backgroundColor: "hsl(0deg, 0%, 78%)",
      // outline: '1px solid slategrey',
      borderRadius: 40,
    },
    "*::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "hsl(0deg, 0%, 68%)",
      // outline: '1px solid slategrey',
      borderRadius: 40,
    },
    /* Up */
    "::-webkit-scrollbar-button:single-button:vertical:decrement": {
      backgroundColor: "rgba(200, 200, 200,1)",
      // color: 'blue'
      // backgroundColor: 'red',
      // borderBottomLeftRadius: '1rem'
      borderBottomLeftRadius: "0.5rem",
      borderBottomRightRadius: "0.5rem",
    },
    "::-webkit-scrollbar-button:single-button:vertical:increment": {
      backgroundColor: "rgba(200, 200, 200,1)",
      // color: 'blue'
      // backgroundColor: 'red',
      // borderTopLeftRadius: '1rem'

      borderTopLeftRadius: "0.5rem",
      borderTopRightRadius: "0.5rem",
    },
    "::-webkit-scrollbar-button:single-button:horizontal:decrement": {
      backgroundColor: "rgba(200, 200, 200,1)",
      // color: 'blue'
      // backgroundColor: 'red',
      // borderBottomLeftRadius: '1rem'
      borderRadius: "0.5rem",
    },
    "::-webkit-scrollbar-button:single-button:horizontal:increment": {
      backgroundColor: "rgba(200, 200, 200,1)",
      // color: 'blue'
      // backgroundColor: 'red',
      // borderTopLeftRadius: '1rem'
      borderRadius: "0.5rem",
    },
  },
});
// const cookies = new Cookies();
// cookies.set('jack', 'Loo', { path: '/' });
console.log("GA", process.env.REACT_APP_GA_ID);
ReactGA.initialize(process.env.REACT_APP_GA_ID);
const callback = (list) => {
  list.getEntries().forEach((entry) => {
    console.log(entry, entry.responseStart - entry.requestStart);
    ReactGA.event({
      category: "Load Performace",
      action: "Server Latency",
      value: Math.round(entry.responseStart - entry.requestStart),
    });
  });
};

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

var observer = new PerformanceObserver(callback);
observer.observe({ entryTypes: ["navigation"] });

class App extends React.Component {
  persistentAlert = null;
  hidden = null;

  state = {
    open: this.props.user.new === 1 ? true : false,
  };

  // storageChange = (event) => {
  //     if (event.key === 'skygeni-user' && document[this.hidden]) {
  //         if (JSON.parse(localStorage.getItem('skygeni-user')) === null) {
  //             this.props.signout()
  //         }
  //         if (JSON.parse(localStorage.getItem('skygeni-user'))) {
  //             this.props.softLogin()
  //         }
  //     }
  // }

  storageChange = (event) => {
    console.log(localStorage.getItem("skygeni-user"));
    if (event.key === "skygeni-user" && document[this.hidden]) {
      if (localStorage.getItem("skygeni-user") === null) {
        this.props.softSignout(); // Sync UI only
      }
      if (localStorage.getItem("skygeni-user")) {
        this.props.softLogin();
      }
    }
  };

  componentDidMount = () => {
    console.log("app loaded");

    console.log(this.props.user, "user");
    if (this.props.user === "") {
      this.props.getUser();
    }
    if (this.props.user !== "") {
      //this.props.loadNavItems(this.props.user.userName)
    }
    window.addEventListener(
      "storage",
      (event) => this.storageChange(event),
      false
    );

    if (typeof document.hidden !== "undefined") {
      this.hidden = "hidden";
      this.visibilityChange = "visibilitychange";
    } else if (typeof document.msHidden !== "undefined") {
      this.hidden = "msHidden";
      this.visibilityChange = "msvisibilitychange";
    } else if (typeof document.webkitHidden !== "undefined") {
      this.hidden = "webkitHidden";
      this.visibilityChange = "webkitvisibilitychange";
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    console.log(this.props, "props");

    // Send user ID to Google Analytics immediately after login
    if (
      this.props.loggedIn &&
      !prevProps.loggedIn &&
      this.props.user &&
      this.props.user.UserID
    ) {
      console.log("Sending user ID to GA after login:", this.props.user.UserID);
      ReactGA.gtag("set", "user_properties", { user_id: this.props.user.UserID });
    }

    if (this.props.alert.id !== prevProps.alert.id) {
      console.log('[App] Alert received:', this.props.alert);
      // Check if toast should be shown based on page context (suppresses info/success toasts on RCC)
      const shouldShow = toastSuppressionService.shouldShowToast(this.props.alert);
      console.log('[App] Should show toast?', shouldShow);
      if (shouldShow) {
        console.log('[App] Showing toast:', this.props.alert.message);
        this.props.enqueueSnackbar(
          this.props.alert.message || "Something went wrong",
          {
            variant: this.props.alert.type || "error",
          }
        );
      } else {
        console.log('[App] Toast suppressed for:', this.props.alert.message);
      }
    }
    if (this.props.persistentAlert !== "" && prevProps.persistentAlert === "") {
      // Check if persistent alert toast should be shown based on page context
      const shouldShowPersistent = toastSuppressionService.shouldShowToast(this.props.persistentAlert);
      console.log('[App] Should show persistent alert?', shouldShowPersistent, this.props.persistentAlert);
      if (shouldShowPersistent) {
        console.log('[App] Showing persistent alert:', this.props.persistentAlert.message);
        this.persistentAlert = this.props.enqueueSnackbar(
          this.props.persistentAlert.message,
          {
            variant: this.props.persistentAlert.type,
            persist: true,
          }
        );
      } else {
        console.log('[App] Persistent alert suppressed for:', this.props.persistentAlert.message);
        // Set to null so we don't try to close a non-existent snackbar
        this.persistentAlert = null;
      }
    }
    if (this.props.persistentAlert === "" && prevProps.persistentAlert !== "") {
      // Only close if we actually showed the persistent alert (not suppressed)
      if (this.persistentAlert !== null) {
        this.props.closeSnackbar(this.persistentAlert);
      }
    }

    if (this.props.passwordUpdated !== prevProps.passwordUpdated) {
      if (this.props.passwordUpdated) {
        this.setState({ open: false });
      }
    }
  };

  changePage = (text) => {
    this.props.changePage(text);
  };

  handleClose = () => {
    var userNew = 0;

    this.props.changeUser(userNew);
    this.setState({
      open: false,
    });
  };

  render() {
    const { classes } = this.props;
    const firstNavSection = this.props.user?.elements?.[0];
    const shouldShowRccAsHome =
      Array.isArray(firstNavSection?.charts) &&
      firstNavSection.charts.some(
        (c) => c?.Chart_Name === "Revenue Command Center"
      );
    return (
      <div className={classes.root}>
        <ErrorBoundary>
          <CssBaseline />
          <AutoUpdateAlert />
          {console.log(this.props.loggedIn)}
          {this.props.loggedIn ? (
            <NavBar
              currentPage={this.props.currentPage}
              firstName={this.props.user.firstName}
              lastName={this.props.user.lastName}
              changePage={this.changePage}
              signout={this.props.signout}
              title={this.props.title}
              company={this.props.user.company}
            >
              {this.props.currentPage === "Home" && (
                <ErrorBoundary>
                  {shouldShowRccAsHome ? <RevenueCommandCenter /> : <Dashboard />}
                </ErrorBoundary>
              )}
              {this.props.currentPage === "Enhanced Insights" && (
                <ErrorBoundary>
                  {/* <EnhancedInsights company={this.props.user.company} /> */}
                  <EnhancedInsightsV2 company={this.props.user.company} />
                </ErrorBoundary>
              )}
              {this.props.currentPage === "Favorites" && (
                <ErrorBoundary>
                  {/* <EnhancedInsights company={this.props.user.company} /> */}
                  <Favourites company={this.props.user.company} />
                </ErrorBoundary>
              )}
              {this.props.currentPage === "Rep Performance" && (
                /* this.props.user.company === 'C0002' && */ <ErrorBoundary>
                  <RepPerformanceV2 company={this.props.user.company} />
                </ErrorBoundary>
              )}
              {this.props.currentPage === "Other Insights" && (
                <ErrorBoundary>
                  {/* <EnhancedInsights company={this.props.user.company} /> */}
                  <OtherInsights company={this.props.user.company} />
                </ErrorBoundary>
              )}
               {this.props.currentPage === "Growth Modeling" && (
                <ErrorBoundary>
                  {/* <EnhancedInsights company={this.props.user.company} /> */}
                  <GrowthModeling company={this.props.user.company} />
                </ErrorBoundary>
              )}
               {this.props.currentPage === "Pipeline Build & Sufficiency" && (
                <ErrorBoundary>
                  {/* <EnhancedInsights company={this.props.user.company} /> */}
                  <PipelineandBuildSuffiecy company={this.props.user.company} />
                </ErrorBoundary>
              )}
                 {this.props.currentPage === "Pipeline Velocity & Conversion" && (
                <ErrorBoundary>
                  {/* <EnhancedInsights company={this.props.user.company} /> */}
                  <PipelineVelocityandConversion company={this.props.user.company} />
                </ErrorBoundary>
              )}
                {this.props.currentPage === "Market Intel & Growth Levers" && (
                <ErrorBoundary>
                  {/* <EnhancedInsights company={this.props.user.company} /> */}
                  <MarketIntelandGrowthLevers company={this.props.user.company} />
                </ErrorBoundary>
              )}
                 {this.props.currentPage === "Sales Productivity" && (
                <ErrorBoundary>
                  {/* <EnhancedInsights company={this.props.user.company} /> */}
                  <SalesProductivity company={this.props.user.company} />
                </ErrorBoundary>
              )}
                    {this.props.currentPage === "Growth Science Insights" && (
                <ErrorBoundary>
                  {/* <EnhancedInsights company={this.props.user.company} /> */}
                  <GrowthScienceInsights company={this.props.user.company} />
                </ErrorBoundary>
              )}

{this.props.currentPage === "Custom Scorecards" && (
                <ErrorBoundary>
                  {/* <EnhancedInsights company={this.props.user.company} /> */}
                  <PersonalizedScorecards company={this.props.user.company} />
                </ErrorBoundary>
              )}
               {this.props.currentPage === "Pipeline Progression" && (
                <ErrorBoundary>
                  {/* <EnhancedInsights company={this.props.user.company} /> */}
                  <PipelineProgressionCharts company={this.props.user.company} />
                </ErrorBoundary>
              )}
              {this.props.currentPage === "Product Insights" && (
                /* this.props.user.company === 'C0002' && */ <ErrorBoundary>
                  <ProductInsights company={this.props.user.company} />
                </ErrorBoundary>
              )}
              {this.props.currentPage === "Customer Success" && (
                /* this.props.user.company === 'C0002' && */ <ErrorBoundary>
                  <CustomerSuccess company={this.props.user.company} />
                </ErrorBoundary>
              )}
              {this.props.currentPage === "Sales Compensation" && (
                <ErrorBoundary>
                  <QuotaLetters company={this.props.user.company} />
                </ErrorBoundary>
              )}
              {this.props.currentPage === "Marketing Support Requests" && (
                <ErrorBoundary>
                  <MarketingRequests company={this.props.user.company} />
                </ErrorBoundary>
              )}
               {this.props.currentPage === "Marketing" && (
                <ErrorBoundary>
                  <MarketingRequests company={this.props.user.company} />
                </ErrorBoundary>
              )}
              {this.props.currentPage === "Settings" && (
                <ErrorBoundary>
                  <Settings />
                </ErrorBoundary>
              )}
            </NavBar>
          ) : (
            <ErrorBoundary>
              <LoginView />
            </ErrorBoundary>
          )}
          <Dialog
            onClose={this.handleClose}
            open={this.state.open}
            aria-labelledby="reset-password"
          >
            <DialogContent>
              <Box mt={2} mb={3}>
                <ResetPasswordFormikComponent
                  type="changepasswordfirstime"
                  title="Reset your password"
                  changePass={this.props.updatePass}
                  errorMessage={""}
                  open={false}
                  alert={{}}
                  classes={{}}
                  setState={{}}
                  persistentAlert={{}}
                  handleChangeLocation={{}}
                  forgotPass={{}}
                  forgotPassEmail={{}}
                />
              </Box>
            </DialogContent>
          </Dialog>
        </ErrorBoundary>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    currentPage,
    loggedIn,
    persistentAlert,
    alert,
    user,
    passwordUpdated,
  } = state.app;
  console.log(JSON.parse(localStorage.getItem("skygeni-user")), "localstorage");
  return {
    currentPage,
    loggedIn,
    persistentAlert,
    alert,
    user,
    passwordUpdated,
  };
}

const mapDispatchToProps = (dispatch) => ({
  getUser: () => {
    dispatch({ type: "get_user_data_request" });
    appService.getUser().then(
      (json) => {
        dispatch({ type: "get_user_data_success", user: json.user });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_user_data_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_user_data_failure", error });
      }
    );
  },

  loadNavItems: (userName) => {
    dispatch({ type: "get_nav_items_check_request" });
    appService.getNavData(userName).then(
      (json) => {
        dispatch({ type: "get_nav_items_check_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_nav_items_check_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_nav_items_check_failure", error });
      }
    );
  },
  changeUser: (userNew) => {
    dispatch({ type: "change_user_new_value", userNew });
  },
  updatePass: (password) => {
    dispatch({ type: "update_pass_request" });
    appService.updatePass(password).then(
      (json) => {
        dispatch({ type: "update_pass_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "update_pass_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "update_pass_failure", error });
      }
    );
  },
  changePage: (text) => {
    console.log("GA ->", text);
    ReactGA.send({ hitType: "pageview", page: text });
    dispatch({ type: "change_page", text });
    localStorage.setItem("skygeni-user-page", text);
    localStorage.removeItem("skygeni-user-enhancedPage");
    localStorage.removeItem("skygeni-user-SettingsPage");
    localStorage.removeItem("skygeni-user-repPage");
    localStorage.removeItem("skygeni-user-productPage");
    localStorage.removeItem("skygeni-user-customerSuccessPage");
    localStorage.removeItem("skygeni-user-quotaGenerationPage");
    localStorage.removeItem("skygeni-user-pipelineProgressionPage");
    localStorage.removeItem("skygeni-user-pipelineVelocityandConversionPage")
    localStorage.removeItem("skygeni-user--pipelineBuildandSuficencyPage")
    localStorage.removeItem("skygeni-user-marketIntelandGrowthLeversPage");
    localStorage.removeItem("skygeni-user-salesProductivityPage");
    localStorage.removeItem("skygeni-user-growthScienceInsightsPage");
    localStorage.removeItem("skygeni-user-growthModelingPage");
    localStorage.removeItem("skygeni-user-othersPage")
  },
  signout: () => {
    appService.logout().then(
      (json) => {
        dispatch({ type: "signout", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({ type: "login_failure", error: "Something went wrong" });
        else dispatch({ type: "login_failure", error });
      }
    );
  },
  softSignout: () => {
    dispatch({ type: "soft_signout" });
  },

  softLogin: () => {
    dispatch({ type: "soft_login" });
  },
});

const connectedApp = connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withSnackbar(App)));
export { connectedApp as App };
